import * as React from 'react';

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CrossIcon = (props: SvgIconProps) => {

  return (
    <SvgIcon {...props}>
      <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M3.05025 13.4497L12.9497 3.55021' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
        <path d='M3.05025 3.55029L12.9497 13.4498' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
      </svg>
    </SvgIcon>
  );
}

export default CrossIcon;